var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNothingFound = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 198,
  height: 164,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M64.417 117.308c12.424-20.18-3.253-38.12-15.35-47.042-2.091-1.542-5-.445-5.675 2.064-8.502 31.64 5.215 42.438 16.82 46.473a3.56 3.56 0 0 0 4.205-1.495Z",
  fill: "#F7F4ED",
  stroke: "#D0D5DA",
  strokeWidth: 2
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#D0D5DA",
  strokeWidth: 2,
  strokeLinecap: "round",
  d: "m46.337 71.858 14.249 44.232M51.16 86.45l-6.446-3.023"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  transform: "matrix(-.92501 -.37994 -.46866 .88338 55.312 100.131)",
  stroke: "#D0D5DA",
  strokeWidth: 2,
  strokeLinecap: "round",
  d: "M1-1h10.544"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#D0D5DA",
  strokeWidth: 2,
  strokeLinecap: "round",
  d: "m58.395 109.9-6.446-3.023M51.875 86.23l3.623-6.13"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  transform: "matrix(.5501 -.8351 .88494 .46571 56.154 99.871)",
  stroke: "#D0D5DA",
  strokeWidth: 2,
  strokeLinecap: "round",
  d: "M1-1h10.544"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#D0D5DA",
  strokeWidth: 2,
  strokeLinecap: "round",
  d: "m59.11 109.68 3.622-6.13"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M126.913 116.62c-9.539-21.694 8.45-37.313 21.656-44.493 2.283-1.24 5.014.245 5.338 2.823 4.083 32.507-10.985 41.322-23.034 43.727a3.559 3.559 0 0 1-3.96-2.057Z",
  fill: "#F7F4ED",
  stroke: "#D0D5DA",
  strokeWidth: 2
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  stroke: "#D0D5DA",
  strokeWidth: 2,
  strokeLinecap: "round",
  d: "m151.054 74.078-20.179 41.861M144.276 87.873l6.8-2.111"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  transform: "matrix(.96837 -.2495 .3431 .9393 138.288 100.854)",
  stroke: "#D0D5DA",
  strokeWidth: 2,
  strokeLinecap: "round",
  d: "M1-1h10.544"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  stroke: "#D0D5DA",
  strokeWidth: 2,
  strokeLinecap: "round",
  d: "m133.894 110.108 6.8-2.111M143.599 87.556l-2.748-6.569"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  transform: "matrix(-.43039 -.90264 -.94044 .33996 137.488 100.48)",
  stroke: "#D0D5DA",
  strokeWidth: 2,
  strokeLinecap: "round",
  d: "M1-1h10.544"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  stroke: "#D0D5DA",
  strokeWidth: 2,
  strokeLinecap: "round",
  d: "m133.217 109.792-2.748-6.569"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  d: "M76 103.783c-4-1.6-3-27.333-2-40l36.5-3.5c4.667-1.166 14.4-1 16 9 2 12.5-1 11-2 13.5-.8 2-3.333 1.834-4.5 1.5v17c.5.167.2 1.6-5 6s-26.5 1.834-36.5 0c.833-.5 1.5-1.9-2.5-3.5Z",
  fill: "#FAF8F2"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  d: "m86.165 51.345-.636-18.121 13.838 1.61-1.548 24.054s-2.876-3.261-5.486-4.8c-2.187-1.29-6.168-2.743-6.168-2.743Z",
  fill: "#FAF8F2",
  stroke: "#D0D5DA",
  strokeWidth: 2
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  d: "M105.498 39.777c6.36-3.568 5.709-17.208 3.024-22.181-.314-.87-1.695-3.02-4.712-4.673-3.771-2.064-10.393.292-15.046 1.126-3.722.667-3.903 8.008-3.528 11.595-.142-.13-.678-.54-1.687-1.144-3.984-2.259-9.044 2.88-5.942 8.037 2.482 4.126 6.625 1.996 8.386.416 4.12 9.394 13.146 10.392 19.505 6.824Z",
  fill: "#FAF8F2",
  stroke: "#D0D5DA",
  strokeWidth: 2
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  d: "M105.498 39.777c6.36-3.568 5.709-17.208 3.024-22.181-.314-.87-1.695-3.02-4.712-4.673-3.771-2.064-10.393.292-15.046 1.126-3.722.667-3.903 8.008-3.528 11.595-.142-.13-.678-.54-1.687-1.144-3.984-2.259-9.044 2.88-5.942 8.037",
  stroke: "#D0D5DA",
  strokeWidth: 2
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  d: "M90.669 21.261c.38 4.553-4.049 4.954-6.31 4.586-.078-.2-.61-.787-2.114-1.532-1.505-.744-2.947-.471-3.48-.242-.844-2-2.518-7.43-2.464-13.145.054-5.716 5.29-6.034 7.9-5.478.318-.491 1.513-1.664 3.762-2.424 10.063-2.928 15.22 2.54 17.305 3.46 2.084.92 5.07-.65 5.089-.243-.287.83-1.974 1.387-2.782 1.561 1.66.574 3.678.097 4.479-.213.359.39.029 2.324-4.159 6.931-4.187 4.607-13.979 2.095-18.351.263.217.262.745 1.924 1.125 6.476Z",
  fill: "#F7F4ED",
  stroke: "#D0D5DA",
  strokeWidth: 2
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  d: "M83.302 27.784c-1.329-.753-3.913-1.609-3.626.99.359 3.247 1.774 2.975 3.8 2.674M103.89 23.13c.09 1.9.524 5.851 1.532 6.456 1.008.605-.336 1.513-1.134 1.89",
  stroke: "#D0D5DA",
  strokeWidth: 2
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  stroke: "#D0D5DA",
  strokeWidth: 2,
  strokeLinecap: "round",
  d: "M100.304 35.001h6.229"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  d: "M74.505 64.374c-1.6 13.487-3.291 40.598 2.744 41.146 7.543.686 17.83 1.372 19.201.686 1.372-.686 2.743-8.23 2.743-16.459M77.935 56.145c1.371-1.829 5.349-5.76 10.286-4.115 4.938 1.646 6.63 3.886 6.858 4.8M114.28 56.83c-3.292-6.035-6.858-5.715-8.229-4.8l.686 4.115c.457.228 1.783.96 3.428 2.057 2.058 1.372 4.115 43.889 4.115 45.947 0 2.057 5.486 0 5.486-2.058 1.372-17.144-1.371-37.717-5.486-45.26Z",
  stroke: "#D0D5DA",
  strokeWidth: 2
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  d: "M77.933 106.206c-.457.915-.823 2.881 1.371 3.429 2.743.686 25.375 5.486 35.662-.685 2.194-2.195 2.743-3.658 2.743-4.115M81.362 98.662c-2.194-1.097-1.371-6.4-.686-8.915.258-1.097 1.023-1.371 1.373-1.371 2.972 0 9.052.274 9.601 1.371.686 1.372.686 8.915-.686 9.601-1.371.686-6.859.686-9.602-.686Z",
  stroke: "#D0D5DA",
  strokeWidth: 2
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  d: "M79.991 91.805c1.829.685 6.72 1.92 11.658 1.371M120 88.472c-1-.372-3-.447-3 2.232 0 2.678 1 4.835 1.5 5.58h1.5M120.451 84.947c3.429.229 9.327-3.291 5.486-19.201-4.8-19.887-10.972-34.289-10.286-34.974.548-.549-2.971-.229-4.799 0l4.799 28.802",
  stroke: "#D0D5DA",
  strokeWidth: 2
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  d: "m130.134 18.48-20.119 7.75 1.697 8.08 17.257 1.154 1.165-16.984Z",
  stroke: "#D0D5DA",
  strokeWidth: 2
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  d: "M135.005 27.055c-.037 2.479-.654 4.666-1.57 6.193-.931 1.554-2.046 2.253-3.057 2.238-1.012-.015-2.106-.748-2.989-2.329-.869-1.554-1.42-3.759-1.383-6.238.038-2.479.654-4.666 1.57-6.193.931-1.554 2.046-2.253 3.058-2.238 1.011.015 2.105.748 2.989 2.329.869 1.555 1.419 3.759 1.382 6.238ZM117.121 19.284l-19.12 7.766 1.606 8.077 16.394 1.142 1.12-16.985Z",
  fill: "#FAF8F2",
  stroke: "#D0D5DA",
  strokeWidth: 2
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  d: "M122.991 27.873c-.037 2.48-.654 4.666-1.569 6.194-.931 1.553-2.047 2.253-3.058 2.237-1.012-.015-2.105-.748-2.989-2.328-.869-1.555-1.42-3.76-1.383-6.238.038-2.48.655-4.666 1.57-6.194.931-1.553 2.047-2.253 3.058-2.238 1.012.016 2.105.748 2.989 2.33.869 1.554 1.42 3.758 1.382 6.237Z",
  fill: "#FAF8F2",
  stroke: "#D0D5DA",
  strokeWidth: 2
})), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  d: "M74.614 63.871c-1.097-7.68 6.4-9.6 10.287-9.6 2.285 1.37 7.542 5.897 10.285 13.029V33.01c0-5.486 1.95-8.411 4.693-9.097 2.743-.686 12.344-2.057 7.544-.686-4.801 1.372-3.322 7.726-4.008 11.84-.685 4.115 10.379 51.816 1.265 55.366-8.337 3.246-28.694-16.962-30.066-26.563Z",
  fill: "#FAF8F2"
})), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
  d: "M95.186 76.215V67.3m0 0V33.01c0-5.486 1.95-8.411 4.693-9.097 2.743-.686 12.344-2.057 7.544-.686-4.801 1.372-3.322 7.726-4.008 11.84-.685 4.115 10.379 51.816 1.265 55.366-8.337 3.246-28.694-16.962-30.066-26.563-1.097-7.68 6.4-9.6 10.287-9.6 2.285 1.37 7.542 5.897 10.285 13.029ZM94.393 23.228c.457-1.371 2.194-3.84 5.486-2.743M109.479 20.485c-.457-1.371-2.743-2.057-4.114-1.371",
  stroke: "#D0D5DA",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
  d: "m75.144 143.149 2.216-32.961a1.998 1.998 0 0 1 2.205-1.855c6.434.686 18.005 1.851 24.435 1.606 4.551-.173 7.646-.872 9.744-1.704 1.5-.595 3.591.228 3.837 1.823l5.065 32.921a2 2 0 0 1-1.977 2.304h-43.53a2 2 0 0 1-1.995-2.134Z",
  fill: "#FAF8F2",
  stroke: "#D0D5DA",
  strokeWidth: 2
})), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
  d: "M81.02 147.759c-40.686 9.608-59.851-28.604-66.104-52.393-.66-2.513 1.362-4.87 3.954-4.698 57.702 3.838 65.86 33.056 65.039 53.61a3.747 3.747 0 0 1-2.889 3.481Z",
  fill: "#F7F4ED",
  stroke: "#D0D5DA",
  strokeWidth: 2
})), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
  stroke: "#D0D5DA",
  strokeWidth: 2,
  strokeLinecap: "round",
  d: "m18.853 95.274 60.849 47.195M40.1 111.237l-1.162-12.813"
})), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
  transform: "matrix(-.04167 -.99913 .99025 -.13927 58.07 124.632)",
  stroke: "#D0D5DA",
  strokeWidth: 2,
  strokeLinecap: "round",
  d: "M1-1h18.447"
})), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
  stroke: "#D0D5DA",
  strokeWidth: 2,
  strokeLinecap: "round",
  d: "m72.007 135.359-1.162-12.813M39.417 112.14l-12.645 2.375"
})), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
  transform: "matrix(-.97265 .2323 .13596 .99071 57.203 125.779)",
  stroke: "#D0D5DA",
  strokeWidth: 2,
  strokeLinecap: "round",
  d: "M1-1h18.447"
})), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
  stroke: "#D0D5DA",
  strokeWidth: 2,
  strokeLinecap: "round",
  d: "m71.324 136.264-12.645 2.374"
})), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
  d: "M116.603 147.474c40.637 9.818 59.998-28.296 66.373-52.052.673-2.51-1.336-4.878-3.929-4.718-57.722 3.54-66.029 32.717-65.314 53.275a3.746 3.746 0 0 0 2.87 3.495Z",
  fill: "#F7F4ED",
  stroke: "#D0D5DA",
  strokeWidth: 2
})), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
  stroke: "#D0D5DA",
  strokeWidth: 2,
  strokeLinecap: "round",
  d: "m179.039 95.31-61.091 46.88M157.71 111.163l1.23-12.807"
})), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
  transform: "matrix(.0468 -.9989 -.98952 -.14437 139.672 124.466)",
  stroke: "#D0D5DA",
  strokeWidth: 2,
  strokeLinecap: "round",
  d: "M1-1h18.447"
})), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
  stroke: "#D0D5DA",
  strokeWidth: 2,
  strokeLinecap: "round",
  d: "m125.68 135.121 1.228-12.807M158.39 112.072l12.633 2.44"
})), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
  transform: "matrix(.97144 .2373 -.14106 .99 140.533 125.617)",
  stroke: "#D0D5DA",
  strokeWidth: 2,
  strokeLinecap: "round",
  d: "M1-1h18.447"
})), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
  stroke: "#D0D5DA",
  strokeWidth: 2,
  strokeLinecap: "round",
  d: "m126.359 136.03 12.633 2.44"
})), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
  d: "M97.715 145.926c1.35-18.349-15.431-25.744-27.344-28.064-2.55-.497-4.68 1.769-4.138 4.31 5.302 24.871 18.63 28.031 28.4 26.952a3.473 3.473 0 0 0 3.082-3.198Z",
  fill: "#F7F4ED",
  stroke: "#D0D5DA",
  strokeWidth: 2
})), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
  stroke: "#D0D5DA",
  strokeWidth: 2,
  strokeLinecap: "round",
  d: "m68.017 120.101 26.157 26.845M76.635 128.557l-5.427.12"
})), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
  transform: "matrix(-.99748 .07099 -.027 .99964 84.807 137.216)",
  stroke: "#D0D5DA",
  strokeWidth: 2,
  strokeLinecap: "round",
  d: "M1-1h8.218"
})), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
  stroke: "#D0D5DA",
  strokeWidth: 2,
  strokeLinecap: "round",
  d: "m90.406 143.045-5.428.12M77.095 128.12l.395-5.414"
})), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
  transform: "matrix(.1214 -.9926 .99972 .02366 85.328 136.721)",
  stroke: "#D0D5DA",
  strokeWidth: 2,
  strokeLinecap: "round",
  d: "M1-1h8.218"
})), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
  stroke: "#D0D5DA",
  strokeWidth: 2,
  strokeLinecap: "round",
  d: "m90.867 142.608.395-5.415"
})), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
  d: "M99.14 145.699c-.409-16.086 14.225-23.624 25.027-26.479 2.639-.697 4.932 1.662 4.27 4.311-5.507 22.049-17.273 25.816-26.042 25.471a3.387 3.387 0 0 1-3.256-3.303Z",
  fill: "#F3F1EA",
  stroke: "#D0D5DA",
  strokeWidth: 2
})), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
  transform: "rotate(133.515 37.837 87.118) skewX(-.118)",
  stroke: "#D0D5DA",
  strokeWidth: 2,
  strokeLinecap: "round",
  d: "M1-1h35.746"
})), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
  transform: "matrix(.99951 -.03126 -.05154 .99867 117.964 130.119)",
  stroke: "#D0D5DA",
  strokeWidth: 2,
  strokeLinecap: "round",
  d: "M1-1h4.798"
})), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
  transform: "matrix(.99984 .01795 -.00267 1 111.207 137.537)",
  stroke: "#D0D5DA",
  strokeWidth: 2,
  strokeLinecap: "round",
  d: "M1-1h7.312"
})), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
  transform: "matrix(.99951 -.03126 -.05154 .99867 104.964 144.126)",
  stroke: "#D0D5DA",
  strokeWidth: 2,
  strokeLinecap: "round",
  d: "M1-1h4.798"
})), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
  transform: "matrix(-.04326 -.99906 -.99206 .12577 117.642 129.819)",
  stroke: "#D0D5DA",
  strokeWidth: 2,
  strokeLinecap: "round",
  d: "M1-1h4.798"
})), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
  transform: "matrix(-.09236 -.99573 -.99702 .07713 110.745 137.107)",
  stroke: "#D0D5DA",
  strokeWidth: 2,
  strokeLinecap: "round",
  d: "M1-1h7.312"
})), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
  transform: "matrix(-.04326 -.99906 -.99206 .12577 104.641 143.827)",
  stroke: "#D0D5DA",
  strokeWidth: 2,
  strokeLinecap: "round",
  d: "M1-1h4.798"
})), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
  d: "M79.5 15.783c-1-3.334-1.2-9.4 6-7 .666-2.167 4.3-5.6 13.5-2",
  stroke: "#fff",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
  d: "M20.5 104.283c4.167 15.167 20.3 44.9 51.5 42.5M178.059 102.76c-3.855 15.249-19.375 45.307-50.618 43.547",
  stroke: "#FAF8F2",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
  d: "M131 21.283c.673 1.41 1.683 5.385.337 10M119 22.283c.673 1.41 1.683 5.385.337 10",
  stroke: "#fff",
  strokeWidth: 2,
  strokeLinecap: "round"
})));
export default SvgNothingFound;